/*
 * @Author: zhao - 🍉
 * @Date: 2022-02-14 20:54:50
 * @LastEditTime: 2022-02-14 23:28:39
 * @LastEditors: zhao - 🍉
 * @Description: 收房合同房租周期 - 列表
 * @FilePath: /zhzj-admin/src/page/RentCycle/index.jsx
 */
import React, { useRef } from 'react'
import TableHelper from '../../components/TableHelper'
import { formatTime } from '../../utils'
import RentCycleUpdate from './update'
import { fetchRentCycleDelete, fetchRentCycleList } from "../../services/rentCycle";
import PageWrap from '../../components/PageWrap';
import QueryString from 'qs';
import { Button, Divider, message, Popconfirm } from 'antd';
const RentCycle = (props) => {
    let RentCycleUpdateRef = useRef()
    const TableHelperRef = useRef()
    const { buildingId } = QueryString.parse(props.location.search, { ignoreQueryPrefix: true })

    const handleEdit = (id) => {
        RentCycleUpdateRef.open(buildingId,id ).then(() => {
            TableHelperRef.current.postDataSource()
        })
    }
    const handleDelete = (id) => {
        fetchRentCycleDelete({ rentCycleId: id }).then(() => {
            message.success('删除成功')
            TableHelperRef.current.postDataSource()
        })
    }
    const columns = [
        { title: '租金', dataIndex: 'rent',  },
        { title: '执行日', dataIndex: 'executionDay',  },
        { title: '周期开始期数', dataIndex: 'cycleStart' },
        { title: '周期结束期数', dataIndex: 'cycleEnd' },
        { title: '创建时间', dataIndex: 'createTime', render: text => formatTime(text, 'YYYY-MM-DD HH:mm') },
        { title: '操作', dataIndex: 'action', render: (text, record) => {
            return (
                <React.Fragment>
                    <a onClick={() => handleEdit(record.id)}>编辑</a>
                    <Divider type="vertical" />
                    <Popconfirm title="确认删除吗" onConfirm={() => handleDelete(record.id)}>
                        <a >删除</a>
                    </Popconfirm>
                </React.Fragment>
            )
        }}
    ]

    const parseRequestData = (data) => {
        return {...data, id: buildingId}
    }
    const parseResponse = (data) => {
        return { total: data.length, dataSource: data }
    }
    return (
        <PageWrap>
            <Button icon="plus" type="primary" onClick={() => handleEdit()}>新增</Button>
            <TableHelper 
                ref={TableHelperRef}
                columns={columns} 
                parseRequestData={parseRequestData}  
                parseResponse={parseResponse}
                request={fetchRentCycleList} 
            />
            <RentCycleUpdate  getRef={ref => RentCycleUpdateRef = ref} />
        </PageWrap>
    )
}

export default RentCycle



// WEBPACK FOOTER //
// ./src/page/RentCycle/index.jsx